// MF-67 — Shared input look for journal forms: white field on the grey page, 8px radius.
export const inputSx = { '& .MuiOutlinedInput-root': { backgroundColor: '#fff', borderRadius: '8px' } }

// Two-column form layout (main + side panel) that stacks on small screens.
export const twoColumnSx = {
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 3fr) minmax(300px, 2fr)' }
}
